import { regExValidator } from '../../shared/validators/reg-ex.validator';

export const errorCodeCodeRegExValidator = regExValidator(new RegExp('^(F\\d{1})?\\d{4}$'), 'Code must match (F0)0000');
export const errorCodeCodeDefaultPlaceholer = 'eg. (F5)4321';
